import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from 'react-router-dom';
import Logo from './images/electra_logo_light_small.jpg';
import '../scss/header.scss';

function Header(props) {
  return (
    <Navbar className="navbar-container" expand="lg" sticky="top">
      <div className="header-nowrap">
        <Navbar.Brand href="/">
          <img className="logo" src={Logo} alt="Electra Technical Sales"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      </div>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mx-auto text-center justify-content-center h5">
          <NavLink activeClassName="active" className="nav-link pl-3" to="/" exact>Home</NavLink>
          { props.visablePages.products ? <NavLink activeClassName="active" className="nav-link pl-3" to="/products" exact>Products</NavLink> : '' }
          { props.visablePages.linecards ? <NavLink activeClassName="active" className="nav-link pl-3" to="/linecard" exact>Line Card</NavLink> : '' }
          { props.visablePages.distributors ? <NavLink activeClassName="active" className="nav-link pl-3" to="/distributors" exact>Distributors</NavLink> : '' }
          { props.visablePages.contactus ? <NavLink activeClassName="active" className="nav-link pl-3" to="/contactus" exact>Contact Us</NavLink> : '' }
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
